import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import ComponentHeaderTitles from "../ComponentHeaderTitles";
import { isRodaJCAction } from "../../config/generalConfig";
import { useEffect } from "react";

const EntiteitKiezer = ({ entiteit, setChosenEntiteit, setBedrijfsnaam, setKvkNummer, agentConfig }) => {
    const ChosenEntiteit = {
        ZAKELIJK: "Zakelijk",
        PARTICULIER: "Particulier"
    }
    const [selectedEntiteit, setSelectedEntiteit] = React.useState(entiteit || ChosenEntiteit.ZAKELIJK);



    useEffect(() => {
        if (isRodaJCAction()) {
            setSelectedEntiteit(ChosenEntiteit.PARTICULIER);
            setChosenEntiteit(ChosenEntiteit.PARTICULIER);
            setBedrijfsnaam("");
            setKvkNummer("");
        }


        // Controleer beschikbaarheid van zakelijke producten
        else if (!agentConfig?.businessProductsAvailable && selectedEntiteit === ChosenEntiteit.ZAKELIJK) {
            setSelectedEntiteit(ChosenEntiteit.PARTICULIER);
            setChosenEntiteit(ChosenEntiteit.PARTICULIER);
        }

        // Controleer beschikbaarheid van particuliere producten
        else if (!agentConfig?.consumerProductsAvailable && selectedEntiteit === ChosenEntiteit.PARTICULIER) {
            setSelectedEntiteit(ChosenEntiteit.ZAKELIJK);
            setChosenEntiteit(ChosenEntiteit.ZAKELIJK);
        }

        else {
            setChosenEntiteit(selectedEntiteit);
        }

    }, [location.pathname, setChosenEntiteit, setBedrijfsnaam, setKvkNummer, agentConfig, selectedEntiteit]);

    // setChosenEntiteit(selectedEntiteit);


    const StyledCard = styled(Card)({
        marginBottom: "1rem",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        cursor: "pointer",
        "&.selected": {
            backgroundColor: "#f0f0f0",
        },
    });

    /**
     * Handles the click event when a entiteit card is clicked.
     *
     * @param {string} entiteit - The selected prodentiteituct.
     */
    const handleCardClick = (entiteit) => {
        setSelectedEntiteit(entiteit);
        setChosenEntiteit(entiteit);
        // clear bedrijfsnaam and kvkNummer if entiteit is not zakelijk
        if (entiteit !== ChosenEntiteit.ZAKELIJK) {
            setBedrijfsnaam("");
            setKvkNummer("");
        }
    };

    return (
        <div>
            <ComponentHeaderTitles title="Mogen we particulier of zakelijk energie leveren?" />
            <FormControl component="fieldset">
                <RadioGroup
                    name="entiteit"
                    value={selectedEntiteit}
                    onChange={(e) => handleCardClick(e.target.value)}
                >
                    {agentConfig?.businessProductsAvailable && (
                        <StyledCard
                            className={selectedEntiteit === ChosenEntiteit.ZAKELIJK ? "selected" : ""}
                            onClick={() => handleCardClick(ChosenEntiteit.ZAKELIJK)}
                        >
                            <CardContent>
                                <FormControlLabel
                                    value={ChosenEntiteit.ZAKELIJK}
                                    control={<Radio />}
                                    label={
                                        <div className="icon-text-wrapper">
                                            <div className="icon-as-zakelijk icon-size"></div>
                                            <Typography variant="h5" component="h2">
                                                {ChosenEntiteit.ZAKELIJK}
                                            </Typography>
                                        </div>
                                    }
                                />
                            </CardContent>
                        </StyledCard>
                    )}
                    {agentConfig?.consumerProductsAvailable && (
                        <StyledCard
                            className={selectedEntiteit === ChosenEntiteit.PARTICULIER ? "selected" : ""}
                            onClick={() => handleCardClick(ChosenEntiteit.PARTICULIER)}
                        >
                            <CardContent>
                                <FormControlLabel
                                    value={ChosenEntiteit.PARTICULIER}
                                    control={<Radio />}
                                    label={
                                        <div className="icon-text-wrapper">
                                            <div className="icon-as-particulier icon-size"></div>
                                            <Typography variant="h5" component="h2">
                                                {ChosenEntiteit.PARTICULIER}
                                            </Typography>
                                        </div>
                                    }
                                />
                            </CardContent>
                        </StyledCard>
                    )}
                </RadioGroup>
            </FormControl>
        </div>
    );
}
EntiteitKiezer.displayName = "EntiteitKiezer";
export default EntiteitKiezer;
